<template>
  <v-list v-if="dts.vdescripcion== 'Administrador'" dense nav left align="left">
    <v-list-item v-for="item in items" :key="item.title" :to="item.link">
      <v-list-item-icon>
        <v-icon color="primary">{{ item.icon }}</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>

  <v-list v-else-if="dts.vdescripcion== 'Usuario Depedencia'" dense nav left align="left">
    <v-list-item v-for="item in itemsU" :key="item.title" :to="item.link">
      <v-list-item-icon>
        <v-icon color="primary">{{ item.icon }}</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { axiosSingleton } from "@/plugins/axios";
import  fraccionServices  from "../../services/FraccionService";

//let apiUrl = 'https://colmenac.ugto.mx/rg/Transparencia/'
//let apiUrl = 'https://localhost:44340/'
let apiUrl = 'https://enjambrec.ugto.mx/RG/Transparencia/'

export default {
  data: () => ({
    dts: "",
    items: [
      { title: "Inicio", icon: "desktop_mac", link: "/" },
      { title: "Unidad", icon: "ballot", link: "/DtUnidad" },
      { title: "Periodo", icon: "event_note", link: "/CatPeriodo" },
      { title: "Usuarios", icon: "person_add", link: "/CatUsuarios" },
      { title: "Fracciones", icon: "sort", link: "/CatFraccion" },
      { title: "Reportes", icon: "equalizer", link: "/Cumplimiento" }
    ],
    itemsU: [
      { title: "Inicio", icon: "desktop_mac", link: "/" },
      { title: "Fracciones", icon: "sort", link: "/CatFraccion" }
    ]
  }),
  props: {
    nue: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions({
      signOutOidc: "oidc/signOutOidc",
      obtenerEmpleado: "obtenerEmpleado"
    }),

    add(item) {
      this.alterTablero(item);
    },

    initialize(nue) {
      let self = this;
   
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.usInicio(this.nue).then(r => {
        this.dts = r.data[0];

       console.log("descripcion LBAR", this.dts);
      });
    }
  },
  computed: {
    ...mapGetters({
      oidcUser: "oidcStore/oidcUser"
    })
  },
  async mounted() {
    //window.addEventListener('vuexoidc:userLoaded', await this.obtenerEmpleado)
    await window.addEventListener('vuexoidc:userLoaded', async (e) => {
      this.obtenerEmpleado(e)
    })},
  created() {
    let self = this;
    self.initialize();
  }
};
</script>
